import { Action } from '@ngrx/store';
import { CompareETLState } from '../states/compare-etl.state';

export const ADD_COMPARE_ETL = '[COMPARE_ETL] Add';
export const REMOVE_COMPARE_ETL = '[COMPARE_ETL] Remove';
export const UPDATE_COMPARE_ETL_COUNT = '[COMPARE_ETL] Update Count';
export const UPDATE_COMPARE_ETL_SELECTED_CONNECTIONS_OBJS = '[COMPARE_ETL] Update Selected Connections Objs';
export const UPDATE_COMPARE_ETL_SELECTED_CONNECTIONS_IDS = '[COMPARE_ETL] Update Selected Connections IDs';
export const UPDATE_COMPARE_ETL_PROPERTIES = '[COMPARE_ETL] Update Properties';
export const UPDATE_COMPARE_ETL_PROPERTIES_OBJ = '[COMPARE_ETL] Update Properties Obj';
export const UPDATE_COMPARE_ETL_CONNECTIONS_LIST = '[COMPARE_ETL] Update Connections list';
export const SET_COMPARE_ETL_CONNECTIONS = '[COMPARE_ETL] set connections';

export class AddCompareETL implements Action {
	readonly type = ADD_COMPARE_ETL;

	constructor(public payload: CompareETLState) {
	}
}

export class RemoveCompareETL implements Action {
	readonly type = REMOVE_COMPARE_ETL;

	constructor(public payload: number) {
	}
}

export class UpdateCompareETLCount implements Action {
	readonly type = UPDATE_COMPARE_ETL_COUNT;

	constructor(public payload: { count: string }) {
	}
}

export class UpdateCompareETLSelectedConnectionsObjs implements Action {
	readonly type = UPDATE_COMPARE_ETL_SELECTED_CONNECTIONS_OBJS;

	constructor(public payload: { selected_connections_objs: Array<any> }) {
	}
}

export class UpdateCompareETLSelectedConnectionsIDs implements Action {
	readonly type = UPDATE_COMPARE_ETL_SELECTED_CONNECTIONS_IDS;

	constructor(public payload: { selected_connections_ids: string }) {
	}
}

export class UpdateCompareETLProperties implements Action {
	readonly type = UPDATE_COMPARE_ETL_PROPERTIES;

	constructor(public payload: { properties: object }) {
	}
}

export class UpdateCompareETLPropertiesObj implements Action {
	readonly type = UPDATE_COMPARE_ETL_PROPERTIES_OBJ;

	constructor(public payload: { properties_obj: object }) {
	}
}

export class UpdateCompareETLConnectionsList implements Action {
	readonly type = UPDATE_COMPARE_ETL_CONNECTIONS_LIST;

	constructor(public payload: { connections_list: object }) {
	}
}

export class SetCompareEtlConnections implements Action {
	readonly type = SET_COMPARE_ETL_CONNECTIONS;

	constructor(public payload: any) {
	}
}

export type Actions =
	AddCompareETL |
	RemoveCompareETL |
	UpdateCompareETLConnectionsList |
	UpdateCompareETLSelectedConnectionsIDs |
	UpdateCompareETLSelectedConnectionsObjs |
	UpdateCompareETLCount |
	UpdateCompareETLProperties |
	UpdateCompareETLPropertiesObj |
	SetCompareEtlConnections;
